import { render, staticRenderFns } from "./Controls.vue?vue&type=template&id=931e90a0&scoped=true&"
import script from "./Controls.vue?vue&type=script&lang=js&"
export * from "./Controls.vue?vue&type=script&lang=js&"
import style0 from "./Controls.vue?vue&type=style&index=0&id=931e90a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931e90a0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Modal: require('/Users/azeem/Baseops/Clients/Superian/code/stratify/components/Modal.vue').default})
